import VueRouter from 'vue-router';
import VueCompositionApi from '@vue/composition-api';
import Root from 'src/root/root.vue';
import SizeToFit from 'src/components/size-to-fit/size-to-fit.vue';
import Routes from './client-routes.js';
const _ = require('lodash');
const Vue = require('vue');
const Vuetify = require('vuetify');
Vue.config.productionTip = false;
Vue.prototype._ = _;
Vue.use(Vuetify);
Vue.use(VueCompositionApi);
Vue.use(VueRouter);
Vue.component('size-to-fit', SizeToFit);
const router = new VueRouter({
    mode: 'history',
    routes: Routes,
});
new Vue({
    el: '#root',
    router,
    // @ts-ignore
    vuetify: new Vuetify({}),
    render: (h) => { return h(Root); },
});
